import ACCESS from "~/core/access";
import {
    Approvals,
    Breakdown,
    CalendarSchedule,
    Expenses,
    Overview,
    ReportProgress,
} from "./widgets";

export const WIDGETS = [
    {
        name: "overview",
        title: "Month Overview",
        widget: Overview.Widget,
        preview: Overview.Preview,
        access: ACCESS.adminTime,
    },
    {
        name: "project-breakdown",
        title: "Project Breakdown",
        widget: Breakdown.Project,
        preview: Breakdown.Preview,
        access: ACCESS.adminTime,
    },
    {
        name: "feecode-breakdown",
        title: "Feecode Breakdown",
        widget: Breakdown.Feecode,
        preview: Breakdown.Preview,
        access: ACCESS.adminTime,
    },
    {
        name: "report-progress",
        title: "Report Progress",
        widget: ReportProgress.Widget,
        preview: ReportProgress.Preview,
        access: ACCESS.adminTime,
    },
    {
        name: "calendar-schedule",
        title: "Calendar Schedule",
        widget: CalendarSchedule.Widget,
        preview: CalendarSchedule.Preview,
    },
    {
        name: "expenses",
        title: "Active Expenses",
        widget: Expenses.Widget,
        preview: Expenses.Preview,
        access: ACCESS.adminExpenses,
    },
    {
        name: "approvals",
        title: "Active Approvals",
        widget: Approvals.Widget,
        preview: Approvals.Preview,
        access: ACCESS.adminApproval,
    },
];
